






import Vue from "vue";
import coreApiClient from "@/services/apis/coreApiClient";
import userManager from "@/services/userManager";
import DataContainer from "@vuetifyx/common/DataContainer";

export default Vue.extend({
  data() {
    return {
      self: this,
      tableOptions: null,
      item: null,
      importItems: [],
      insertDialogContainer: new DataContainer(),
    };
  },
  methods: {
    makeTableOptions(item) {
      return {
        attrs: {
          "item-key": "_id",
          "sort-by": "createdTime",
          "sort-desc": true,
        },
        content: {
          name: `Phí vận chuyển - ${item?.name || ""}`,
          urlEnabled: true,
          search: {},
          filters: {
            filters: {
              region: {
                type: "text",
                attrs: {
                  label: "Khu vực",
                },
                rules: {
                  equal_to: {},
                },
              },
              startTime: {
                type: "XDateTimePicker",
                rules: {
                  greater_than_or_equal_to: {
                    attrs: {
                      label: "Ngày bắt đầu (>=)",
                      xOptions: {
                        content: {
                          resultFilter: (m) => m.startOf("day"),
                        },
                      },
                    },
                  },
                  less_than_or_equal_to: {
                    attrs: {
                      label: "Ngày bắt đầu (<=)",
                      xOptions: {
                        content: {
                          resultFilter: (m) => m.endOf("day"),
                        },
                      },
                    },
                  },
                },
              },
              endTime: {
                type: "XDateTimePicker",
                rules: {
                  greater_than_or_equal_to: {
                    attrs: {
                      label: "Ngày kết thúc (>=)",
                      xOptions: {
                        content: {
                          resultFilter: (m) => m.startOf("day"),
                        },
                      },
                    },
                  },
                  less_than_or_equal_to: {
                    attrs: {
                      label: "Ngày kết thúc (<=)",
                      xOptions: {
                        content: {
                          resultFilter: (m) => m.endOf("day"),
                        },
                      },
                    },
                  },
                },
              },
            },
          },
          displayFields: {
            region: {
              text: "Khu vực",
              sortable: true,
            },
            weightFrom: {
              text: "Cân nặng từ (kg)",
              sortable: true,
            },
            weightTo: {
              text: "Cân nặng đến (kg)",
              sortable: true,
            },
            startTime: {
              text: "Ngày bắt đầu",
              sortable: true,
              options: { filter: "dateTime" },
            },
            endTime: {
              text: "Ngày kết thúc",
              sortable: true,
              options: { filter: "dateTime" },
            },
            value: {
              text: "Giá",
              sortable: true,
              options: { filter: "currency" },
            },
            discountPercentage: {
              text: "% giảm giá",
              sortable: true,
            },
            action: {},
          },
          topActionButtons: {
            import: userManager.checkRole(["kt"]) && {
              attrs: {
                color: "default",
                dark: false,
              },
              content: {
                text: "Nhập Excel",
                icon: "mdi-upload",
              },
              target: {
                tooltip: { content: { text: "Nhập Excel" } },
                dialog: {
                  handlers: {
                    initialize() {
                      this.options.content.buttons.save.states.enabled = new DataContainer(false);
                    },
                  },
                  content: {
                    toolbar: {
                      title: "Nhập Excel",
                    },
                    content: {
                      type: "XForm",
                      makeAttrs(attrs, dialog) {
                        attrs.xModel = dialog.options.content.buttons.save.states.enabled;
                        attrs.xContext = dialog;
                        attrs.xData = new DataContainer({});
                        return attrs;
                      },
                      attrs: {
                        xOptions: {
                          content: {
                            sections: {
                              default: {
                                fields: {
                                  file: {
                                    type: "file",
                                    attrs: {
                                      label: "File",
                                      required: true,
                                    },
                                  },
                                  startTime: {
                                    type: "XDateTimePicker",
                                    attrs: {
                                      label: "Ngày bắt đầu",
                                      required: true,
                                    },
                                  },
                                  endTime: {
                                    type: "XDateTimePicker",
                                    attrs: {
                                      label: "Ngày kết thúc",
                                      required: true,
                                    },
                                  },
                                  discountPercentage: {
                                    type: "number",
                                    attrs: {
                                      label: "% giảm giá",
                                    },
                                  },
                                },
                              },
                            },
                          },
                        },
                      },
                    },
                    buttons: {
                      save: {
                        content: {
                          text: "Tải lên",
                        },
                        states: {},
                        on: {
                          async xClick({ self }) {
                            const dialog = self.context();
                            const btn = dialog.context();
                            const dataTable = btn.context();
                            const form = dialog.contentContainer.value;
                            const data = form.getData();
                            self.loading.value = true;
                            const result = await dataTable.execute(
                              async () => {
                                return await coreApiClient.call(
                                  "shippingFeeItems",
                                  "import",
                                  {
                                    shippingCompanyAccountId: dataTable.context().$route.params.shippingCompanyAccountId,
                                    startTime: data.startTime,
                                    endTime: data.endTime,
                                    discountPercentage: data.discountPercentage,
                                  },
                                  data
                                );
                              },
                              undefined,
                              {
                                disableLoading: true,
                                willRefresh: true,
                              }
                            );
                            self.loading.value = false;
                            if (result) {
                              dialog.hide();
                            }
                          },
                        },
                      },
                    },
                  },
                },
              },
            },
          },
          template: {
            itemActionButtons: {
              edit: userManager.checkRole(["kt"]) && {
                target: {
                  dialog: {
                    ext: {
                      subTitleMaker: "region",
                    },
                  },
                },
              },
              delete: userManager.checkRole(["admin"]) && {},
            },
          },
          findAllOptionsFilter(options) {
            options.filters.push({
              key: "shippingCompanyAccountId",
              operator: "equal_to",
              value: this.context().$route.params.shippingCompanyAccountId,
            });
            return options;
          },
        },
        ext: {
          dataProvider: {
            async findAll(options) {
              const { items, count } = await coreApiClient.call("shippingFeeItems", "findAll", options);
              return [items, count];
            },
            async insert(item, dataTable) {
              item.shippingCompanyAccountId = dataTable.context().$route.params.shippingCompanyAccountId;
              return await coreApiClient.call("shippingFeeItems", "create", undefined, item);
            },
            async update(item) {
              return await coreApiClient.call(
                "shippingFeeItems",
                "update",
                {
                  id: item._id,
                },
                {
                  data: item,
                }
              );
            },
            async delete(item) {
              return await coreApiClient.call("shippingFeeItems", "delete", {
                id: item._id,
              });
            },
          },
          default: {
            defaultInputs: {
              region: {
                attrs: {
                  label: "Khu vực",
                  required: true,
                },
              },
              weightFrom: {
                type: "number",
                attrs: {
                  label: "Cân nặng từ (kg)",
                },
              },
              weightTo: {
                type: "number",
                attrs: {
                  label: "Cân nặng đến (kg)",
                  required: true,
                },
              },
              startTime: {
                type: "XDateTimePicker",
                attrs: {
                  label: "Ngày bắt đầu",
                  required: true,
                },
              },
              endTime: {
                type: "XDateTimePicker",
                attrs: {
                  label: "Ngày kết thúc",
                  required: true,
                },
              },
              value: {
                type: "number",
                attrs: {
                  label: "Giá",
                  required: true,
                },
              },
              discountPercentage: {
                type: "number",
                attrs: {
                  label: "% giảm giá",
                },
              },
            },
            insertForm: userManager.checkRole(["kt"]) && {
              content: {
                fieldNames: ["region", "weightFrom", "weightTo", "startTime", "endTime", "value", "discountPercentage"],
              },
            },
            editForm: userManager.checkRole(["kt"]) && {
              content: {
                fieldNames: ["region", "weightFrom", "weightTo", "startTime", "endTime", "value", "discountPercentage"],
              },
            },
            delete: userManager.checkRole(["admin"]) && {
              confirmDisplayField: "region",
            },
          },
        },
      };
    },
  },
  async created() {
    this.item = await coreApiClient.call("shippingCompanyAccounts", "findById", {
      id: this.$route.params.shippingCompanyAccountId,
    });
    this.tableOptions = this.makeTableOptions(this.item);
  },
});
